import {ApiClientCommunication} from 'neo-common';
import {Request} from './Request';
import {GameResponse} from '../Responses/GameResponse';
import {SpinBet} from '../Types/SpinBet';

const action = 'BuyFeature';

/**
 * @class BuyFeatureRequest - request "BuyFeature"
 */
export class BuyFeatureRequest extends Request<GameResponse> {
    /**
     * @property bet - Spin total bet info. BuyFeatureConversion x originalBet.
     */
    bet: SpinBet;

    /**
     * @property originalBet - Spin original bet info.
     */
    originalBet: SpinBet;

    /**
     * @property buyFeatureName - Name of the buying feature.
     */
    buyFeatureName: string;

    constructor(bet: SpinBet, originalBet: SpinBet, buyFeatureName: string, customData?: any) {
        super(customData);
        this.bet = bet;
        this.originalBet = originalBet;
        this.buyFeatureName = buyFeatureName;
    }

    public static get requestName(): string {
        return action;
    }

    actionName(): string {
        return action;
    }

    createResponse(responseJson: ApiClientCommunication.Types.RawResponseType): GameResponse {
        return new GameResponse(responseJson);
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Requests/BuyFeatureRequest.ts
 **/